(function () {
    const TIMEOUT   = 2000;
    const DESIGN    = window.Shopify && Shopify.designMode;
    const IN_IFRAME = window.top !== window.self;

    if (DESIGN || IN_IFRAME) return;

    window.addEventListener('beforeunload', () => {
        if (/\/products\/|\/search/.test(location.pathname)){
            sessionStorage.setItem('previousUrl', location.href);
        } else {
            'scrollRestoration' in history && (history.scrollRestoration = 'auto');
        }
    });

    const last = sessionStorage.getItem('previousUrl');
    const need =
        last && (/\/collections\/|\/search/.test(location.pathname));

    if (!need) return;

    'scrollRestoration' in history && (history.scrollRestoration = 'manual');
    document.documentElement.classList.add('smart-return--hidden');

    const handle = last.split('/').pop().split('?')[0];

    let started   = performance.now();
    function revealWhenReady() {
        const card = document.querySelector(`[data-scroll-to-item="${handle}"]`);
        const expired = performance.now() - started > TIMEOUT;

        if (card) {
            card.scrollIntoView({behavior:'instant', block:'center'});
            finish();
        } else if (expired) {
            finish();
        } else {
            requestAnimationFrame(revealWhenReady);
        }
    }

    function finish(){
        document.documentElement.classList.remove('smart-return--hidden');
        sessionStorage.removeItem('previousUrl');
    }

    if (document.readyState === 'loading'){
        document.addEventListener('DOMContentLoaded', revealWhenReady, {once:true});
    } else {
        revealWhenReady();
    }
})();